import React from 'react';
import { ArrowRight } from 'lucide-react';
import { BusinessHero } from '@/components/ui/content-blocks';

const CtoServiceHeader = () => {
  return (
    <BusinessHero
      title="EXTERNE IT-LEITUNG AS A SERVICE"
      description="Planung, Budget & Kontrolle für Firmen mit 10 – 50 Mitarbeitern"
      details="Du willst digital vorankommen, ohne dich durch IT-Fachsprache und Anbieter-Versprechen zu kämpfen? Als externe IT-Leitung geben wir dir einen klaren Fahrplan, schützen dein Budget und stellen sicher, dass jede IT-Entscheidung deinem Unternehmen nützt – nicht den Umsätzen einer Agentur."
      backgroundStyle="orange"
      primaryCTA={{
        label: "Jetzt Termin sichern",
        href: "#contact",
        icon: <ArrowRight size={16} />
      }}
      secondaryCTA={{
        label: "Mehr erfahren",
        href: "#cto-features"
      }}
    />
  );
};

export default CtoServiceHeader;
